export default function withinBounds(value, min = 0, max = 100) {
    if(value === '' || value < min) {
        return min;
    }
    if(value > max) {
        return max;
    }

    return value;
}